module.exports = __webpack_public_path__ + "img/wizard-03.ed947a7f.png";